import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    width: 2.125rem;
    height: 2.125rem;

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledLink = styled.a`
  &&& {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    height: auto;
    background: ${COLORS.PALE_YELLOW};
    padding: 0.25rem;
    border: none;
    border-radius: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;

    :hover {
      background: ${COLORS.PALE_YELLOW};
    }
  }

  svg {
    transform: scale(1.5);
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;
